export const NAVIGATION_URLS = {
  PROTECTED_FALLBACK_PAGE: '/Login',
  PUBLIC_FALLBACK_PAGE: '/Login',
  STUDENT_FALLBACK_PAGE: '/StudetnJoinCodeEntry',
  VIEW_ONLY_PARENT_URL: 'https://www.knowledgehook.com',
  FORBIDDEN_FALLBACK_PAGE: '/forbidden'
};
